import {
  SELECT_ELEMENT,
  SELECT_PROCESS,
  SELECT_SUBMISSION,
  CHANGE_SUBMISSION
} from "../actions/types";

const initialState = {
  element: null,
  process: null,
  submission: { submission: null, type: null }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SELECT_ELEMENT:
      return {
        ...state,
        element: action.payload
      };
    case SELECT_PROCESS: {
      return {
        ...state,
        process: action.payload
      };
    }
    case SELECT_SUBMISSION: {
      return {
        ...state,
        submission: action.payload
      };
    }
    case CHANGE_SUBMISSION: {
      const { key, value } = action.payload;
      const newSubmission = Object.assign({}, state.submission.submission);
      set(newSubmission, key, value);

      return {
        ...state,
        submission: { ...state.submission, submission: newSubmission }
      };
    }
    default:
      return state;
  }
}

function set(object, address, newValue) {
  address = address.replace(/^\.+/, "");
  const parts = address.split(/[.[]/);

  console.log({ address, parts, object });

  if (parts.length === 1) {
    object[parts[0]] = newValue;
  } else if (address[0] === "[") {
    const index = address.match(/\[[0-9]+\]/)[0].slice(1, -1);
    const newAddress = address.slice(index.length + 2);

    if (!newAddress) {
      object[Number(index)] = newValue;
    } else {
      set(object[Number(index)], newAddress, newValue);
    }
  } else {
    const newAddress = address.slice(parts[0].length);
    set(object[parts[0]], newAddress, newValue);
  }
}
